import { t } from "i18next";
import { Accordion } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { debugLogPages } from "../../app/helpers/debugHelper";
import CheckListOptionsCatalogState from "./CheckListOptionsCatalogState";
import CheckListOptionsCatalogStateLocat from "./CheckListOptionsCatalogStateLocat";
import CheckListOptionsCatalogStateMulti from "./CheckListOptionsCatalogStateMulti";
import EndUserRemoveFilterOptionsL3 from "./EndUserRemoveFilterOptionsL3";
import PercentajeReactInputRange from "./PercentajeReactInputRange";

const INDICATOR_DEEP = "deep_indicator";
const INDICATOR_PROTECTION = "protection_indicator";
const INDICATOR_APPLICABILITY = "applicability_indicator";
const INDICATOR_RELEVANCE = "relevance_indicator";
const INDICATOR_MITIGATION = "mitigation_indicator";
const INDICATOR_ADAPTATION = "adaptation_indicator";
const INDICATOR_PERFORMANCE = "performance_indicator";

const FILTER_SERIES = "catalogserie_id";

const FILTER_PROBLEMS = "catalogproblem_id"

const FILTER_CIIUS = "catalogciiu_levels";

const FILTER_INSTITUTIONS = "cataloginstitution_levels";
const FILTER_CONTINENTS = "catalogcontinents_id";
const FILTER_REGIONS = "catalogregions_id"
const FILTER_COUNTRIES = "catalogcountries_id";

const INDICATORS_TITLE = "indicators_title";
const INDICATORS_TITLE_INFO = "indicators_title_info";

const L3FilterAssistance = ({
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  itemsPerPage,
  setItemsPerPage,
  moduleSelected,
  setModuleSelected,
  catalogCiiuLevel1Selected,
  setCatalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter
}) => {

  debugLogPages(':: L3FilterAssistance');

  const {
    listSeriesFilter,
    listProblemsFilter,
    deep_indicator_min,
    deep_indicator_max,
    relevance_indicator_min,
    relevance_indicator_max,
    adaptation_indicator_min,
    adaptation_indicator_max,
    mitigation_indicator_min,
    mitigation_indicator_max,
    protection_indicator_min,
    protection_indicator_max,
    performance_indicator_min,
    performance_indicator_max,
    applicability_indicator_min,
    applicability_indicator_max,
  } = useSelector((state) => state.catalog);

  const {
    listCiiusFilter
  } = useSelector((state) => state.catalogCiiu);

  const {
    listInstitutionsFilter
  } = useSelector((state) => state.catalogInstitution);

  const {
    listContinentsFilter, listRegionsFilter, listCountriesFilter
  } = useSelector((state) => state.locationCountry);

  return (
    <div>

      <EndUserRemoveFilterOptionsL3
        searchTextState={searchTextState}
        catalogsToFilter={catalogsToFilter}
        setCatalogsToFilter={setCatalogsToFilter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        moduleSelected={moduleSelected}
        setModuleSelected={setModuleSelected}
        catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
        setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
        indicatorsToFilter={indicatorsToFilter}
        setIndicatorsToFilter={setIndicatorsToFilter} />

      {/*Titulo*/}
      <div style={{ fontWeight: '600', paddingTop: '1em', borderBottom: 'red 0.2em solid', fontSize: '1.4rem' }}>
        <span>{t(
          `${moduleSelected &&
          moduleSelected.key &&
          moduleSelected.key
          }.search.filters`
        )}</span>
      </div>

        <div className="accordionFilter">
          <Accordion defaultActiveKey="0" flush alwaysOpen>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_SERIES}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_SERIES}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogState
                  dataList={listSeriesFilter}
                  title="Series"
                  keyCatalog={`${FILTER_SERIES}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_PROBLEMS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_PROBLEMS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogState
                  dataList={listProblemsFilter}
                  title="Problemas"

                  keyCatalog={`${FILTER_PROBLEMS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="10">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_CIIUS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_CIIUS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateMulti
                  dataList={listCiiusFilter}
                  title="Ciiu"

                  keyCatalog={`${FILTER_CIIUS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="12">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_INSTITUTIONS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_INSTITUTIONS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateMulti
                  dataList={listInstitutionsFilter}
                  title="Fases"

                  keyCatalog={`${FILTER_INSTITUTIONS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="13">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_CONTINENTS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_CONTINENTS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateLocat
                  dataList={listContinentsFilter}
                  title="Continentes"

                  keyCatalog={`${FILTER_CONTINENTS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="14">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_REGIONS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_REGIONS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateLocat
                  dataList={listRegionsFilter}
                  title="Regiones"

                  keyCatalog={`${FILTER_REGIONS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="15">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_COUNTRIES}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_COUNTRIES}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateLocat
                  dataList={listCountriesFilter}
                  title="Paises"

                  keyCatalog={`${FILTER_COUNTRIES}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

          </Accordion>

          <ReactTooltip id={`${FILTER_SERIES}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_SERIES}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_PROBLEMS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_PROBLEMS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_CIIUS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_CIIUS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_INSTITUTIONS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_INSTITUTIONS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_CONTINENTS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_CONTINENTS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_REGIONS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_REGIONS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_COUNTRIES}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_COUNTRIES}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${INDICATORS_TITLE}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.search.${INDICATORS_TITLE_INFO}`
            )}
          </ReactTooltip>

        </div>

        {/*Titulo*/}
      <div style={{ fontWeight: '600', paddingTop: '1em', borderBottom: 'red 0.2em solid', fontSize: '1.4rem' }}>
        <span>{t(
          `${moduleSelected &&
          moduleSelected.key &&
          moduleSelected.key
          }.search.indicators_title`
        )}</span>
      </div>

      <div>
        <div className="accordionFilter">
          {/***Acordeon de indicadores*****/}
          <Accordion defaultActiveKey="2" flush alwaysOpen>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.search.${INDICATORS_TITLE}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${INDICATORS_TITLE}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_DEEP}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={deep_indicator_min}
                    valueMax={deep_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>

                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_PROTECTION}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={protection_indicator_min}
                    valueMax={protection_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>
                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_APPLICABILITY}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={applicability_indicator_min}
                    valueMax={applicability_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>
                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_RELEVANCE}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={relevance_indicator_min}
                    valueMax={relevance_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>
                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_MITIGATION}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={mitigation_indicator_min}
                    valueMax={mitigation_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>
                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_ADAPTATION}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={adaptation_indicator_min}
                    valueMax={adaptation_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>
                <div className="percentItem">
                  <PercentajeReactInputRange

                    indicator_name={`${INDICATOR_PERFORMANCE}`}
                    searchTextState={searchTextState}
                    catalogsToFilter={catalogsToFilter}
                    setCatalogsToFilter={setCatalogsToFilter}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    valueMin={performance_indicator_min}
                    valueMax={performance_indicator_max}
                    moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                    indicatorsToFilter={indicatorsToFilter}
                    setIndicatorsToFilter={setIndicatorsToFilter}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

      </div>
    </div>
  );
};

export default L3FilterAssistance;